//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ConsumeList',
  components: {
    consume: function consume() {
      return import('./components/log');
    }
  }
};